import { Button } from '../../atoms/Button';
import { Typography } from '../../molecules/Typography';

type ButtonProps = {
  label: string;
  topLabel?: string;
  onClick?: () => void;
  selected?: boolean;
};

interface iButtonGroupProps {
  buttons: ButtonProps[];
  className?: string;
  size?: 'small' | 'regular';
}

function ButtonGroup({
  buttons,
  className,
  size = 'regular',
}: iButtonGroupProps) {
  const buttonsClassNames = `
    bg-color-lightest
    text-mono-color-darkest
    font-bold

    rounded-none 
    border-hairline
    border-mono-color-medium

    group-first:md:rounded-l-[999px]
    group-last:md:rounded-r-[999px]

    group-first:rounded-l-none

    group-first:rounded-t-[999px]
    group-last:rounded-b-[999px]

    group-first:md:rounded-tr-none
    group-last:md:rounded-bl-none

    px-[${size === 'small' ? '4' : '6'}]  
  `;

  const buttonItemClassNames = `
    group 
    flex 
    flex-col 
    text-center 
    w-full
  `;

  return (
    <div className={`flex flex-col md:flex-row ${className}`}>
      {buttons.map((button, index) => (
        <div className={buttonItemClassNames} key={index}>
          {button.topLabel && (
            <Typography size='mini' className='mb-1 text-mono-color-darker'>
              {button.topLabel}
            </Typography>
          )}
          <Button
            allowReadOnly
            className={`${buttonsClassNames} ${
              button.selected
                ? `border-color-brand-primary bg-color-brand-primary text-button-color-primary-default`
                : ''
            }`}
            onClick={button.onClick}
            size={size}
            iconSize={size}
            full
          >
            {button.label}
          </Button>
        </div>
      ))}
    </div>
  );
}

export { ButtonGroup };
export type { iButtonGroupProps };
